module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/2_7ac4393bbcd96688da761ca701250dd3.png";